import { useActiveOrganization } from "@/core/context/ActiveOrganizationContext"
import ROUTE_NAMES from "@/core/route/util/routeNames"
import Relay from "@/relay/relayUtils"
import { ZoomConnectButtonQuery } from "@/zoom/connect-button/__generated__/ZoomConnectButtonQuery.graphql"
import useZoomConnectionOnWindowFocus from "@/zoom/util/hook/useZoomConnectionOnWindowFocus"
import { DiscoButtonSkeleton } from "@disco-ui"
import {
  OverridableDiscoButton,
  OverridableDiscoButtonProps,
} from "@disco-ui/button/OverridableDiscoButton"
import { graphql, useLazyLoadQuery } from "react-relay"

type ZoomConnectButtonProps = Omit<OverridableDiscoButtonProps, "onClick">

function ZoomConnectButton({ children, ...props }: ZoomConnectButtonProps) {
  const activeOrganization = useActiveOrganization()

  const { organization } = useLazyLoadQuery<ZoomConnectButtonQuery>(
    graphql`
      query ZoomConnectButtonQuery($id: ID!) {
        organization: node(id: $id) {
          ... on Organization {
            hasZoomIntegration
          }
        }
      }
    `,
    { id: activeOrganization?.id || "" }
  )

  const setConnectZoomButtonState = useZoomConnectionOnWindowFocus({
    hasZoomIntegration: Boolean(organization?.hasZoomIntegration),
  })[1]

  return (
    <OverridableDiscoButton onClick={connectZoom} {...props}>
      {children}
    </OverridableDiscoButton>
  )

  function connectZoom() {
    const win = window.open(
      `${ROUTE_NAMES.ZOOM_LANDING}?organizationSlug=${activeOrganization?.slug}`,
      "_blank"
    )
    win?.focus()
    setConnectZoomButtonState(true)
  }
}

function ZoomConnectButtonSkeleton() {
  return <DiscoButtonSkeleton width={"100%"} />
}

export default Relay.withSkeleton({
  component: ZoomConnectButton,
  skeleton: ZoomConnectButtonSkeleton,
})
